import getApiClient from '@/plugins/api'

export default {
  changePage: function (page) {
    this.page = page
  },

  loadBoardingPlaces() {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    self.searchParams.page = self.page
    self.searchParams.itemsPerPage = self.perPage

    api.get('boarding_places', {
      params: self.searchParams
    })
      .then((result) => {
        self.boardingPlaces = result.data['hydra:member']
        self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  confirmDelete(item) {
    const self = this,
      api = getApiClient(self.$root.$store)

    self.$store.commit('startLoading')

    api.get(`boarding_places/${item.id}?full=true`)
      .then(response => {
        self.deletingObj = response.data
        self.deletingId = item.id
        self.showDeleteConfirmation = true
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  cancelDelete() {
    this.deletingId = null
    this.showDeleteConfirmation = false
  },

  deleteBoardingPlace() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.deletingId

    self.$store.commit('startLoading')

    self.updateReplacementPlace()
      .then(() => {
        self.replacementPlace = null
        api.delete(`boarding_places/${itemId}`)
          .then(() => {
            self.loadBoardingPlaces()
            self.deletingId = null
            self.deletingObj = null
            self.showDeleteConfirmation = false
          })
          .catch(error => {
            console.log(error)
          })
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  updateReplacementPlace() {
    const self = this,
      api = getApiClient(self.$root.$store)

    return new Promise((resolve, reject) => {
      if (!self.replacementPlace) {
        resolve()
      }

      api.post(`boarding_places/replace/`, {
        place: `/boarding_places/${self.deletingId}`,
        replacement: self.replacementPlace
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
